import { getNetwork } from '../utils/getNetwork';
import { API_AUTH } from '../config';

export const getOrganizationTypesApi = () => getNetwork().get(`${API_AUTH}/get/organization/type`);
